import * as React from "react";
import { cn } from "../../utils/cn";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const ButtonComponent = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, type = "button", ...props }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn("bg-xuron-orange py-[9px] px-[17px] rounded-full text-white font-medium text-base", className)}
        {...props}
      >
        {children}
      </button>
    );
  }
);

ButtonComponent.displayName = "Button";

export { ButtonComponent };
